import { e } from "./environment-ddee5959.js";
var r = e, o = r === "NODE";
export {
  o as e
};
